export type RowsEdit<T> = (rows: T[]) => T[]

export type Pending = {
  confirm: () => void
  rollback: () => void
}

export function removeRow<T extends { id: string }>(id: string): RowsEdit<T> {
  return (rows) => rows.filter((r) => r.id !== id)
}

export function patchRow<T extends { id: string }>(id: string, patch: Partial<T>): RowsEdit<T> {
  return (rows) => rows.map((r) => (r.id === id ? { ...r, ...patch } : r))
}

export function insertRow<T extends { id: string }>(row: T): RowsEdit<T> {
  return (rows) => (rows.some((r) => r.id === row.id) ? rows : [...rows, row])
}
